import { useEffect, useState } from "react";

import { Modal, Typography } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { isPedagogicalYearInstitutionActive as isPedagogicalYearInstitutionActiveApi,} from "../../api";
import { useTypedSelector } from "../../app";
import styles from "./HomePage.module.scss";

export const HomePage = () => {
  const currentImportantDate = useTypedSelector(
    (state) => state.application.importantDate
  );

  const [confirmSuccessModalOpen, setConfirmSuccessModalOpen] = useState(false);

  const { t } = useTranslation();

  const handleToggleMessageModal = () => {
    setConfirmSuccessModalOpen((prev) => !prev);
  };

  useEffect(() => {
    (async () => {      
        let isActive = false;
          await isPedagogicalYearInstitutionActiveApi()
          .then((result => {
            isActive = result;
          }));
          if (!isActive) {
            setConfirmSuccessModalOpen(true);
        }
    })();
  }, []);
  
  return (
    <>
      <Container className={styles.container}>
        <div className={styles.welcomeMessage}>
          <Typography variant="heading">
            {t("home.welcomeMessageTitle")}
          </Typography>

          {currentImportantDate && currentImportantDate.eventName && (
            <Typography variant="base">
              {t("home.currentEventMessage", {
                eventName: currentImportantDate.eventName.toLowerCase(),
                dateFrom: hrDate(currentImportantDate.dateTimeFrom!),
                dateTo: hrDate(currentImportantDate.dateTimeTo!),
              })}
            </Typography>
          )}

          <Typography variant="base">
            {t("home.administrationContact")}
            <a href="mailto: eUpisiVrtici@mzom.hr">eUpisiVrtici@mzom.hr</a>
          </Typography>

          <Typography variant="base">
            {t("home.technicalContact")}
            <a href="mailto: helpdesk@skole.hr">helpdesk@skole.hr</a>
          </Typography>
        </div>
      </Container>
      <Modal
        type={"message"}
        open={confirmSuccessModalOpen}
        confirmText={t("common.close")}
        onConfirm={handleToggleMessageModal}
        onClose={handleToggleMessageModal}
      >
        {t("pedagogicalYearInstitution.NotActiveForCurrentPedagogicalYear")}
      </Modal>
    </> 
  );
};
